import styled from 'styled-components';
import { layout, media, remCalc } from '@prisjakt/ui-base';
import { Link } from 'react-router-dom';
import Button from '@prisjakt/ui-button';
import PanelHeaderComponent from '@prisjakt/ui-panel-header';
import BaseFilter from './components/filter';

const buttonHeight = '40px';

export const Filter = styled(BaseFilter)`
  min-width: 0;
  flex: 1 1 0;

  ${media.largeUp`
    max-width: 220px;
    padding-right: ${remCalc(11)};

    @supports (position: sticky) {
      position: sticky;
      top: ${layout.headerHeight.desktop.rem};
      overflow-x: hidden;
      overflow-y: auto;
      max-height: calc(100vh - ${layout.headerHeight.desktop.rem});
      margin-bottom: 10px;
      margin-right: ${layout.pageContent.gutter.rem};
      scroll-behavior: smooth;
      z-index: 5;
    }
  `};

  ${media.mediumDown`
    display: ${props => (props.open ? 'block' : 'none')};
    background: ${p => p.theme.bg.primary};
    position: absolute;
    padding-right: ${layout.pageContent.gutter.rem};
    padding-left: ${layout.pageContent.gutter.rem};
    top: -${layout.headerHeight.desktop.rem};
    left: 0;
    right: 0;
    z-index: 102;
    overflow: auto;
    overflow-y: scroll; /* has to be scroll, not auto */
    -webkit-overflow-scrolling: touch;
  `};

  ${media.smallOnly`
    top: -${layout.headerHeight.mobile.rem};
  `};
`;

export const BrandLink = styled(Link)`
  margin-right: ${layout.spacing.small};
`;

export const BrandLogo = styled.img`
  width: 88px;
  height: 31px;
`;

export const PanelHeaderWrapper = styled.div`
  display: flex;
`;

export const PanelHeader = styled(PanelHeaderComponent)`
  flex: 1 0 auto;
`;

export const FilterButton = styled(Button)`
  max-height: ${buttonHeight};
  margin-right: ${layout.spacing.xSmall};

  ${media.mediumDown`
    display: none;
  `};
`;

export const Column = styled.div`
  padding-right: 0.8rem;
  padding-left: 0.8rem;
  min-width: 0;

  flex: 0 0 ${p => (p.fullWidth ? '100%' : '50%')};
  max-width: ${p => (p.fullWidth ? '100%' : '50%')};
`;
